import { createStore, select, withProps } from '@ngneat/elf';
import { joinRequestResult, trackRequestResult } from '@ngneat/elf-requests';

import { DropdownOption } from '../../../models/dropdown-option';

type RequestKeys = 'fetch-accounts';

interface SwitchAccountsProps {
  customerAccounts: DropdownOption[];
  partnerAccounts: DropdownOption[];
}

const switchAccountsStore = createStore(
  { name: 'switch-accounts' },
  withProps<SwitchAccountsProps>({
    partnerAccounts: [],
    customerAccounts: [],
  })
);

/** Snapshots */

export const switchAccountsStoreSnapshot = () => switchAccountsStore.getValue();

/** Request Results Trackers */

export const trackSwitchAccountsRequests = <T>(keys: RequestKeys[]) =>
  trackRequestResult<T>(keys, {
    skipCache: true,
    preventConcurrentRequest: false,
  });

export const joinSwitchAccountsRequests = <T>(keys: RequestKeys[]) =>
  joinRequestResult<T>(keys);

/** Exposed Variables and Observables */

export const partnerAccounts$ = switchAccountsStore.pipe(
  select(({ partnerAccounts }) => partnerAccounts),
  joinSwitchAccountsRequests(['fetch-accounts'])
);

export const customerAccounts$ = switchAccountsStore.pipe(
  select(({ customerAccounts }) => customerAccounts),
  joinSwitchAccountsRequests(['fetch-accounts'])
);

/** Updater Functions */

export function updatePartnerAccounts(partnerAccounts: DropdownOption[]) {
  switchAccountsStore.update((state) => ({
    ...state,
    partnerAccounts,
  }));
}

export function updateCustomerAccounts(customerAccounts: DropdownOption[]) {
  switchAccountsStore.update((state) => ({
    ...state,
    customerAccounts,
  }));
}

export function resetSwitchAccountsStore() {
  switchAccountsStore.reset();
}
